import { defineMessages } from 'react-intl'

const scope = 'procurify.platform.globalSearch.GlobalSearchSuggestedPrompts'

export default defineMessages({
  heading: {
    id: `${scope}.heading`,
    defaultMessage: 'Try starting a request with Procurify AI',
  },
  listAriaLabel: {
    id: `${scope}.listAriaLabel`,
    defaultMessage: 'Suggested prompts',
  },
  restockOfficeSupplies: {
    id: `${scope}.restockOfficeSupplies`,
    defaultMessage: 'Restock office supplies',
  },
  orderSafetyGear: {
    id: `${scope}.orderSafetyGear`,
    defaultMessage: 'Order safety gear and protective equipment',
  },
  orderCleaningSupplies: {
    id: `${scope}.orderCleaningSupplies`,
    defaultMessage: 'Order cleaning and janitorial supplies',
  },
})
